var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPwClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-804 -104)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h1024v890H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M0 0h1024v890H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 525,
    x: 162,
    y: 80,
    fill: "#FFF",
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303331",
    d: "M831.46 107.121a1.851 1.851 0 0 0 .028-2.576 1.773 1.773 0 0 0-2.53-.028L818 115.452l-10.958-10.93a1.763 1.763 0 0 0-2.53.029 1.84 1.84 0 0 0 .028 2.576L815.448 118l-10.908 10.879a1.851 1.851 0 0 0-.028 2.576c.692.716 1.82.728 2.53.028L818 120.548l10.958 10.93a1.763 1.763 0 0 0 2.53-.029 1.84 1.84 0 0 0-.028-2.576L820.552 118l10.908-10.879z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPwClose);
export default __webpack_public_path__ + "static/media/ic-pw-close.7d474d53765dc2b363fe0f44625a51b7.svg";
export { ForwardRef as ReactComponent };